import axios from "axios";
import {apiUri} from "../../config";
import {push} from "connected-react-router";
import { NotificationManager } from 'react-notifications';

export const FETCH_COMMISSIONS_ATTEMPT = 'FETCH_COMMISSIONS_ATTEMPT';
export const FETCH_COMMISSIONS_SUCCESS = 'FETCH_COMMISSIONS_SUCCESS';
export const FETCH_COMMISSIONS_FAILURE = 'FETCH_COMMISSIONS_FAILURE';

export const CREATE_COMMISSIONS_ATTEMPT = 'CREATE_COMMISSIONS_ATTEMPT';
export const CREATE_COMMISSIONS_SUCCESS = 'CREATE_COMMISSIONS_SUCCESS';
export const CREATE_COMMISSIONS_FAILURE = 'CREATE_COMMISSIONS_FAILURE';

export const FETCH_COMMISSION_ATTEMPT = 'FETCH_COMMISSION_ATTEMPT';
export const FETCH_COMMISSION_SUCCESS = 'FETCH_COMMISSION_SUCCESS';
export const FETCH_COMMISSION_FAILURE = 'FETCH_COMMISSION_FAILURE';

export const SELECT_COMMISSION = 'SELECT_COMMISSION';

export const COMMISSION_UPDATE = 'COMMISSION_UPDATE';

global.loader = false;

export const fetch_commissions = (page) => {
    return (dispatch) => {
        dispatch({type: FETCH_COMMISSIONS_ATTEMPT, page: page});
        axios.get(apiUri + "/commissions?page=" + page)
            .then(json => {
                const response = json.data;
                dispatch({
                    type: FETCH_COMMISSIONS_SUCCESS,
                    data: response.content,
                    page: page,
                    total_pages: response.totalPages
                })
            })
            .catch(err => {
                dispatch({type: FETCH_COMMISSIONS_FAILURE, error: err})
            })
    }
};

export const select_commission = (commission_id) => {
    return (dispatch) => {
        dispatch({type: SELECT_COMMISSION, id: commission_id});
        dispatch(push("/commissions/" + commission_id));
    }
};

export const fetch_commission = (commission_id) => {
    return (dispatch) => {
        dispatch({type: FETCH_COMMISSION_ATTEMPT, id: commission_id});
        axios.get(apiUri + "/commissions/" + commission_id)
            .then(json => {
                dispatch({type: FETCH_COMMISSION_SUCCESS, id: commission_id, data: json.data})
            })
            .catch(err => {
                dispatch({type: FETCH_COMMISSION_FAILURE, id: commission_id, error: err})
            })
    }
};

export const updatePurchaseType = (id , Usertype,Type) => {
    var urlType = apiUri + "/purchases/commission/"+id+"?commissionLevel=NO_EMBARGO&purchaseType="+ Usertype;;
    if(Type==='CUSTOM'){
        urlType = urlType+"_"+Type;      
    }
     return (dispatch) => {
       
        axios.post(urlType,'')
        .then(json => {
            global.loader = false;
            NotificationManager.success("Commission Saved Successfully");
           dispatch(push("/commissions"));

        })
        .catch(err => {
            console.log("Failed to create commission " + err);
            global.loader = false;
            NotificationManager.error("Failed to create commission" + err);
            dispatch({type: CREATE_COMMISSIONS_FAILURE, error: err.response.data.message})
        })
     }
}

export const create_commission = (data,isSubscribe) => {
   
    const pathname = window.location.pathname;
    
     return (dispatch) => {
       
        dispatch({type: CREATE_COMMISSIONS_ATTEMPT});
        axios.post(apiUri + "/commissions",data)
            .then(json => {
                dispatch({type: CREATE_COMMISSIONS_SUCCESS, data: json});
                dispatch(updatePurchaseType(json.data.data.id , isSubscribe ? 'SUBSCRIBER' : 'NONSUBSCRIBER',pathname.includes("/commissions/create")&&'CUSTOM'))
            })
            .catch(err => {     
                console.log("Failed to create commission----> " + err);
                global.loader = false;
                NotificationManager.error("Failed to create commission" + err);
                dispatch({type: CREATE_COMMISSIONS_FAILURE, error: err.response.data.message})
            })
     }
};


export const commissionUpdate = UpdateCommissionId => {
    return dispatch => {
            axios.get(apiUri + "/cases/caseInfo/"+ UpdateCommissionId)
            .then(json => {
                dispatch({type: COMMISSION_UPDATE, 
                    UpdateCommissionResult: json.data})
            })
            .catch(err => {
                console.log("Failed to create commission " + err);
                dispatch({type: CREATE_COMMISSIONS_FAILURE, error: err.response.data.message})
            })
    };
  };


// WEBPACK FOOTER //
// ./src/commissions/redux/actions.js